export default __webpack_public_path__ + "static/media/donauL.63e5218e.jpg";